import { render } from "@/components/pages/specialFeature/spWorkSupport/requirementSpES005/RequirementSpES005.html?vue&type=template&id=071c70ff&scoped=true&external"
import script from "@/components/pages/specialFeature/spWorkSupport/requirementSpES005/RequirementSpES005.js?vue&type=script&lang=js&external"
export * from "@/components/pages/specialFeature/spWorkSupport/requirementSpES005/RequirementSpES005.js?vue&type=script&lang=js&external"

import "@/components/pages/specialFeature/spWorkSupport/requirementSpES005/RequirementSpES005.scss?vue&type=style&index=0&id=071c70ff&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071c70ff"]])

export default __exports__